__turbopack_context__.v({
  "container": "Document-module__SKcj_W__container",
  "nameAndDescription": "Document-module__SKcj_W__nameAndDescription",
});
